(function () {
var $ = function (s) { return document.querySelector(s); };
var tt;
function toast(msg) {
var t = $("#toast"); t.textContent = msg; t.classList.add("on");
clearTimeout(tt); tt = setTimeout(function () { t.classList.remove("on"); }, 2200);
}
function setCount(n) {
var c = $("#bagCount"); c.hidden = n < 1; c.textContent = n;
$("#bagBtn").setAttribute("aria-label", "Bag, " + n + (n === 1 ? " item" : " items"));
}
var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
document.addEventListener("click", function (e) {
var b = e.target.closest("[data-variant]"); if (!b) return;
var card = b.closest(".card"), sel = card && card.querySelector(".vsel");
var id = sel ? sel.value : b.getAttribute("data-variant");
b.disabled = true;
fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
.then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); })
.then(function () { return fetch(root + "cart.js", { headers: { "Accept": "application/json" } }); })
.then(function (r) { return r.json(); })
.then(function (c) { setCount(c.item_count); toast("Added " + b.getAttribute("data-name") + " to your bag"); })
.catch(function () { toast("That didn't go through. Please try again."); })
.then(function () { b.disabled = false; });
});
var rail = $("#rail");
function step(d) { rail.scrollBy({ left: d * 356, behavior: "smooth" }); }
$("#prev").addEventListener("click", function () { step(-1); });
$("#next").addEventListener("click", function () { step(1); });
$("#menuBtn").addEventListener("click", function () {
var p = $("#menuPanel"); p.hidden = !p.hidden;
this.setAttribute("aria-expanded", String(!p.hidden));
});
$("#menuPanel").addEventListener("click", function (e) {
if (e.target.closest("a")) { this.hidden = true; $("#menuBtn").setAttribute("aria-expanded", "false"); }
});
var depths = [["Porcelain", "#F7E3D6"], ["Ivory", "#F0D0B8"], ["Sand", "#E4B999"], ["Honey", "#D2A27B"], ["Caramel", "#BA8761"], ["Cocoa", "#9A6845"], ["Mocha", "#774C33"], ["Espresso", "#4F3022"]];
var unders = [["Cool", [-5, -3, 8]], ["Cool neutral", [-2, -1, 4]], ["Neutral", [0, 0, 0]], ["Warm neutral", [4, 1, -5]], ["Warm", [8, 2, -10]]];
function shift(hex, d) {
var n = parseInt(hex.slice(1), 16), c = [n >> 16, (n >> 8) & 255, n & 255];
return "#" + c.map(function (v, i) { return Math.max(0, Math.min(255, v + d[i])).toString(16).padStart(2, "0"); }).join("");
}
var shades = [];
unders.forEach(function (u, ui) {
depths.forEach(function (d, di) {
shades.push({ code: (di + 1) * 100 + (ui + 1) * 10, depth: d[0], under: u[0], hex: shift(d[1], u[1]) });
});
});
$("#strip").innerHTML = depths.map(function (d) { return '<i style="background:' + d[1] + '"></i>'; }).join("");
$("#gridLabel").innerHTML = depths.map(function (d) { return "<span>" + d[0].slice(0, 4) + "</span>"; }).join("");
var grid = $("#grid");
grid.innerHTML = shades.map(function (s, i) {
return '<button class="sw" data-i="' + i + '" style="background:' + s.hex + '" aria-pressed="false" aria-label="Shade ' + s.code + ' ' + s.depth + ', ' + s.under + ' undertone"></button>';
}).join("");
function pick(i) {
var s = shades[i];
var btns = grid.children;
for (var k = 0; k < btns.length; k++) btns[k].setAttribute("aria-pressed", String(k === i));
$("#bigSwatch").style.background = s.hex;
$("#pvName").textContent = s.code + " " + s.depth;
$("#pvSub").textContent = s.under + " undertone";
}
grid.addEventListener("click", function (e) {
var b = e.target.closest(".sw"); if (b) pick(+b.getAttribute("data-i"));
});
pick(2 * 8 + 3);
})();